import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import MissionStatementPage from "./pages/MissionStatementPage";
import NewsletterPage from "./pages/NewsletterPage";
import TeamPage from "./pages/TeamPage";
import ScenePage from "./pages/ScenePage";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/mission" element={<MissionStatementPage />} />
          <Route path="/newsletter" element={<NewsletterPage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="*" element={<HomePage />} />
        </Route>
        <Route path="/scene" element={<ScenePage />} />
      </Routes>
    </BrowserRouter>
  );
}
